import { loadFont as loadSofadiFont } from '@remotion/google-fonts/SofadiOne';
import { loadFont as loadSoraFont } from '@remotion/google-fonts/Sora';
import { loadFont as laodInconsolataFont } from '@remotion/google-fonts/Inconsolata';
import { loadFont as laodMontserratFont } from '@remotion/google-fonts/Montserrat';
import { loadFont as laodBangersFont } from '@remotion/google-fonts/Bangers';

export const loadAllFonts = () => {
  loadSofadiFont();
  loadSoraFont();
  laodInconsolataFont();
  laodMontserratFont();
  laodBangersFont();
};
